export const heroBenefits = [
  "A 30-minute plan with facilitator wording",
  "Complete workplace cases and role cards",
  "Feedback sheets and real-work application"
];

export const stats = [
  {
    "value": "5",
    "label": "Ready-to-run workshops"
  },
  {
    "value": "30",
    "label": "Minutes per session"
  },
  {
    "value": "5",
    "label": "Included bonuses"
  },
  {
    "value": "$27",
    "label": "USD, one time"
  }
];

export const situations = [
  {
    "id": "requests",
    "label": "Requests sound clear until the work comes back wrong",
    "workshop": "Workshop 1 - Clear Requests",
    "title": "Turn a vague request into a clear agreement",
    "description": "Practice naming the deliverable, owner and deadline, then check whether the request is workable.",
    "outcome": "The receiver can explain what done means and when to confirm it.",
    "pairWith": "Then practice Workshop 2 - Checking Understanding"
  },
  {
    "id": "assumptions",
    "label": "People act on different interpretations of the same message",
    "workshop": "Workshop 2 - Listening and Checking Understanding",
    "title": "Check the meaning before acting",
    "description": "Use a short paraphrase and a focused question to surface an assumption before it becomes extra work.",
    "outcome": "Both people confirm the same next action and what should stay unchanged.",
    "pairWith": "See all five planned workshops"
  },
  {
    "id": "updates",
    "label": "You hear 'almost done' but cannot plan the next step",
    "workshop": "Workshop 3 - Useful Status Updates",
    "title": "Make progress and the next decision visible",
    "description": "Practice separating completed work, remaining work, the next action and the help needed.",
    "outcome": "A teammate knows what is ready, what is conditional and when the next update will arrive.",
    "pairWith": "Pair with Workshop 4 - Clear Work Handoffs"
  },
  {
    "id": "handoffs",
    "label": "Tasks get passed along without a clear new owner",
    "workshop": "Workshop 4 - Clear Work Handoffs",
    "title": "Transfer responsibility with the task",
    "description": "Give the current state, next action and checkpoint, then ask the receiver to read back the agreement.",
    "outcome": "The receiver accepts ownership and can describe the next step.",
    "pairWith": "See Workshop 5 - Clearing Up Misunderstandings"
  },
  {
    "id": "misunderstanding",
    "label": "Small misunderstandings turn into blame",
    "workshop": "Workshop 5 - Clearing Up Everyday Misunderstandings",
    "title": "Reset the agreement using observable facts",
    "description": "Practice naming the mismatch, checking the other person's understanding and agreeing what happens next.",
    "outcome": "The conversation ends with a specific action, owner and time.",
    "pairWith": "See the complete workshop sequence"
  }
];

export const samplePages = [
  {
    "id": "plan",
    "page": "1",
    "label": "Plan",
    "heading": "A planned session",
    "text": ""
  },
  {
    "id": "case",
    "page": "2",
    "label": "Case",
    "heading": "A complete case",
    "text": ""
  },
  {
    "id": "roles",
    "page": "3",
    "label": "Roles",
    "heading": "Ready role cards",
    "text": ""
  },
  {
    "id": "observer",
    "page": "4",
    "label": "Observer",
    "heading": "Behavioral feedback",
    "text": ""
  }
] as const;

export const solutionSteps = [
  {
    "title": "Choose",
    "body": "Select the skill your team needs, or follow the five-week sequence. The included skill check helps you choose."
  },
  {
    "title": "Prepare",
    "body": "Read the supplied plan and print the role cards. The scenarios, dialogue and feedback criteria are already written."
  },
  {
    "title": "Practice",
    "body": "Follow the 30 minutes: 3 opening, 5 demonstration, 15 role rotations, 5 debrief and 2 application."
  },
  {
    "title": "Apply",
    "body": "Each participant chooses one sentence or action to try at work. Reinforce it with a five-minute huddle."
  }
];

export const includedItems = [
  {
    "title": "One complete facilitator guide",
    "body": "Five workshops for requests, listening, updates, handoffs and everyday misunderstandings."
  },
  {
    "title": "Timed facilitator plans",
    "body": "Minute-by-minute agendas and exact wording for every stage."
  },
  {
    "title": "Two cases per workshop",
    "body": "Use one case in the session; keep the other for a separate repeat."
  },
  {
    "title": "Speaker, listener and observer cards",
    "body": "Each participant has the facts and instructions they need."
  },
  {
    "title": "Model dialogues",
    "body": "Read a complete example and compare a less useful response with a clearer one."
  },
  {
    "title": "Observation and application sheets",
    "body": "Give feedback on behavior and choose one action for real work."
  }
];

export const offerIncludes = [
  "Complete guide: five complete 30-minute workshop plans",
  "Exact facilitator scripts for each stage",
  "Ten fictional cases: two per workshop",
  "Speaker, listener and observer role cards",
  "Model dialogues and behavioral observation sheets",
  "Quick-reference cards and real-work application pages"
];
export type SamplePageId = (typeof samplePages)[number]["id"];
